/**
 * Category registry for the help centre.
 *
 * The data lives in `categories.json` rather than this file because it has TWO readers:
 * this typed module (bundled into the app) and `scripts/help/validate.mjs`, which runs in
 * Node during the build and cannot import TypeScript. JSON is the one format both read
 * without a second copy of the list drifting out of sync.
 *
 * A category must be declared before an article can use it — an article whose `category:`
 * is not in this list fails the build. That is deliberate: it stops a typo silently
 * creating a new, orphaned section of the wiki.
 *
 * Categories with no articles are hidden from the guides tab and category pages, so the
 * list can be filled in ahead of the content landing.
 */

import data from "./categories.json";

export type CategoryDef = {
  slug: string;
  title: string;
  summary: string;
  order: number;
};

export const categories: CategoryDef[] = data;

export const categoryBySlug = new Map(categories.map((c) => [c.slug, c]));
